import { UppyFile } from '@uppy/core';
import fetch from 'cross-fetch';
interface PreSignedUrlResponse {
  signedUrl: string;
  fileName: string;
  fileDestinationUrl: string;
  thumbnailDestinationUrl: string;
}

// TODO: union type or enum for FileUploadType
type FileUploadType = string;

export const getPresignedUrlUploadParameters =
  (uploadType: FileUploadType) => (file: UppyFile) =>
    postFileUpload(file, uploadType);

export const postFileUpload = (file: UppyFile, uploadType: FileUploadType) =>
  fetch(
    `${
      process.env.NEXT_PUBLIC_TREND_API
    }/upload/pre-signed-url?uploadType=${uploadType}&fileName=${encodeURI(
      file.name
    )}`,
    {
      method: 'POST',
      headers: {},
    }
  )
    .then((res) => res.json())
    .then(({ signedUrl }: PreSignedUrlResponse) => {
      return {
        method: 'PUT',
        url: signedUrl,
        fields: {},
        headers: {
          ['content-type']: file.type || 'application/x-www-form-urlencoded',
        },
      };
    });
